export default __webpack_public_path__ + "static/token-dcd41314c96242e363e6df0f9abff816.png";